import React, { useState, useEffect } from 'react';
import { BiChevronDown } from 'react-icons/bi';
import {
  Button,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Box,
} from '@chakra-ui/react';
import axios from 'axios';
import { useUserContext } from '../../context/user_context';
import { toast } from 'react-toastify';

function Addresses({ onSelectAddress }) {
  const [addressList, setAddressList] = useState([]);
  const { currentUser } = useUserContext();

  useEffect(() => {
    // Fetch data from the URL when the component mounts
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const userid = currentUser?.id;
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_HOST}/api/user/address/${userid}`
      );
      setAddressList(response.data.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handleAddressSelect = (address1) => {
    onSelectAddress(address1);
  };

  const deleteAddress = async (addressId) => {
    try {
      const userid = currentUser?.id;
      const data = {
        id: addressId,
      };
      await axios.delete(
        `${process.env.REACT_APP_BACKEND_HOST}/api/user/address/${userid}`,
        { data }
      );
      setAddressList(
        addressList.filter((address) => address._id !== addressId)
      );
    } catch (error) {
      console.error('Error deleting address:', error);
    }
  };

  const handleDelete = (event, addressId) => {
    event.stopPropagation(); // Prevents the click event from reaching the MenuButton
    deleteAddress(addressId);
    toast.success('Address Deleted');
  };

  return (
    <Box>
      <Menu>
        <MenuButton
          as={Button}
          rightIcon={<BiChevronDown />}
          width='100%'
          mb='10px'
        >
          Saved addresses
        </MenuButton>
        <MenuList style={{ maxHeight: '400px', overflowY: 'auto' }}>
          {addressList?.length === 0 ? (
            <MenuItem>No addresses saved</MenuItem>
          ) : (
            addressList?.map((item) => (
              <MenuItem
                key={item._id}
                onClick={() => handleAddressSelect(item)}
              >
                <Box
                  maxW={{
                    base: '250px',
                    sm: '300px',
                    md: '350px',
                    lg: '350px',
                  }}
                >
                  <p>
                    {`${item.name}, 
                    ${item.phoneNumber}`}
                  </p>
                  <p>
                    {`
                  ${item.address.line1}, 
                    ${item.address.postal_code}, 
                    ${item.address.city}, 
                    ${item.address.state}, 
                    ${item.address.country}`}
                  </p>
                  <Button
                    backgroundColor='red'
                    onClick={(e) => handleDelete(e, item._id)}
                    marginTop='10px'
                    color='white'
                  >
                    Delete
                  </Button>
                </Box>
              </MenuItem>
            ))
          )}
        </MenuList>
      </Menu>
    </Box>
  );
}

export default Addresses;
